export const ARIA_CURRENT = 'page';
